import ApiModel from './globals/ApiModel';

export default class NotificationVariableModel extends ApiModel {
  static get path() {
    return '/backend/notification_variables/{?id}';
  }
}
